import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useSigninModal } from "../../context/SigninModalContext";
import "./EarnAffiliate.scss";

const beats = [
  {
    n: "01",
    title: "Save products you stand behind",
    body: "Drop finds into your cart from any store. Your taste becomes the catalog.",
  },
  {
    n: "02",
    title: "Share a cart or a link",
    body: "Send it to friends, followers, or your audience. Eligible links stay tagged for you.",
  },
  {
    n: "03",
    title: "Earn when they check out",
    body: "Purchases through your share can pay affiliate commission. Buyers pay the same price.",
  },
];

const EarnAffiliate = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.12 });
  const { openSignin } = useSigninModal();

  return (
    <motion.section
      id="earn"
      className="earn-aff"
      ref={ref}
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: inView ? 1 : 0, y: inView ? 0 : 24 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      <div className="earn-aff__glow" aria-hidden="true" />

      <div className="earn-aff__inner">
        <header className="earn-aff__header">
          <p className="earn-aff__eyebrow">Affiliate revenue</p>
          <h2 className="earn-aff__title">
            Earn on OllaCart when your taste turns into purchases
          </h2>
          <p className="earn-aff__lead">
            Share products or your cart. When someone buys through an eligible
            link, you can earn affiliate revenue at no extra cost to them.
          </p>
        </header>

        <ol className="earn-aff__beats">
          {beats.map((beat, i) => (
            <motion.li
              key={beat.n}
              className="earn-aff__beat"
              initial={{ opacity: 0, y: 16 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.45, delay: 0.1 + i * 0.08 }}
            >
              <span className="earn-aff__num" aria-hidden="true">
                {beat.n}
              </span>
              <h3>{beat.title}</h3>
              <p>{beat.body}</p>
            </motion.li>
          ))}
        </ol>

        <div className="earn-aff__actions">
          <button
            type="button"
            className="earn-aff__btn earn-aff__btn--primary"
            onClick={openSignin}
          >
            Start earning free
          </button>
          <Link className="earn-aff__link" to="/affiliate">
            View earnings dashboard
          </Link>
        </div>
      </div>
    </motion.section>
  );
};

export default EarnAffiliate;
